// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","content":"Header_content__e8Iuw"};